import React from 'react';

import { ArrowDownIcon } from '../../icons/ArrowDownIcon';
import { useDropdown } from './DropdownContext';
import { isIPad } from '../../../utilities/commonUtil';
import Tippy from '../../ReactTippy';

const Select = ({ readOnly, disabled = false }) => {
  const {
    isShowDropdown,
    selectedName,
    decoratorRef,
    handleToggleDropdown,
    isShowToolTip,
  } = useDropdown();

  const handleToggle = () => {
    if (disabled || readOnly) {
      return;
    }
    handleToggleDropdown();
  };

  const getSelectElement = () => {
    return (
      <React.Fragment>
        <div className={`${disabled || readOnly ? 'disable-dropdown' : ''}`}>
          <div className={`dropdown-select`} onClick={handleToggle}>
            <span className='dropdown-select__txt'>{selectedName}</span>
            <ArrowDownIcon className='icon--2_4x form-list__arrow-icon' />
          </div>
        </div>
      </React.Fragment>
    );
  };

  return (
    <div
      className={`dropdown-single-select__header ${
        isShowDropdown ? 'show' : ''
      }`}
      ref={decoratorRef}
    >
      {isShowToolTip && !isIPad() ? (
        <div>
          <Tippy
            duration={10}
            multiple={false}
            arrow={true}
            arrowType='sharp'
            placement='bottom'
            html={renderTooltipContent(selectedName)}
          >
            {getSelectElement()}
          </Tippy>
        </div>
      ) : (
        getSelectElement()
      )}
    </div>
  );
};

const renderTooltipContent = data => {
  const rowStyle = {
    maxWidth: '240px',
    wordWrap: 'break-word',
    color: '#FFF',
    fontSize: '14px',
    lineHeight: '1.5',
    textAlign: 'left',
  };

  return <div style={rowStyle}>{data}</div>;
};

export default Select;



// WEBPACK FOOTER //
// ./src/components/dropdowns/portal/Select.jsx